import { isBefore, parse, sub } from "date-fns";

type CanAddMemberHoldParams = {
  memberHoldEnabled?: boolean | null;
  memberHoldDeadlineHours?: number | null;
  bookingDate?: string | null;
  bookingTime?: string | null;
  now?: Date;
};

export const canAddMemberHold = ({
  memberHoldEnabled,
  memberHoldDeadlineHours,
  bookingDate,
  bookingTime,
  now = new Date(),
}: CanAddMemberHoldParams) => {
  if (!memberHoldEnabled) {
    return false;
  }

  if (!memberHoldDeadlineHours) {
    return true;
  }

  if (!bookingDate || !bookingTime) {
    return false;
  }

  const bookingTimeObj = parse(
    `${bookingDate} - ${bookingTime}`,
    "yyyy-MM-dd - HH:mm:ss",
    now
  );

  if (Number.isNaN(bookingTimeObj.getTime())) {
    return false;
  }

  const cutOffTime = sub(bookingTimeObj, {
    hours: memberHoldDeadlineHours,
  });

  return isBefore(now, cutOffTime);
};
